module.exports = __webpack_public_path__ + "static/media/lifan.84003810.png";